<template>
	<div class="filters-box">
		<div class="filters-box-row">
			<div class="data-picker-box">
				<span>下单时间：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					align="right"
					:clearable='false'
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="order-type-box">
				<span>单据类型：</span>
				<el-select v-model="orderType" placeholder="请选择单据类型" class="order-type-select" size="small">
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.value"
						:value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>采购门店名称:</span>
				<el-input v-model="shopName" placeholder="请输入采购门店名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>

		</div>
		<div class="filters-box-row">
			<div class="order-type-box">
				<span>平台大类：</span>
				<el-select v-model="bigCate"  clearable @change='bigCateChange' filterable placeholder="请选择平台大类" class="order-type-select" size="small">
					<el-option
						v-for="item in categoryList"
						:key="item.value"
						:label="item.bcName"
						:value="item.bcId">
					</el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>平台小类：</span>
				<el-select v-model="samllCate" clearable  filterable placeholder="请选择平台小类" class="order-type-select" size="small">
					<el-option
						v-for="item in smallcategoryList"
						:key="item.value"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</div>

			<div class="order-type-box">
				<span>供货商名称：</span>
				<el-select v-model="organ"  clearable @change='organChange' filterable placeholder="请选择供货商名称" class="order-type-select" size="small">
					<el-option
						v-for="item in organList"
						:key="item.syscodeid"
						:label="item.orgname"
						:value="item.syscodeid">
					</el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>供货商店铺名称：</span>
				<el-select v-model="shop" filterable clearable placeholder="请选择供货商店铺" class="order-type-select" size="small">
					<el-option
						v-for="item in shopList"
						:key="item.organid"
						:label="item.name"
						:value="item.organid">
					</el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>业务员：</span>
				<el-input size='small' v-model='userName' style="width:150px"></el-input>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			categoryList: [],
			smallcategoryList: [],
			organList: [],
			shopList: [],
			bigCate: '',
			organ: '',
			shop: '',
			userName: '',
			samllCate: '',
			options: [
				{ value: '全部' },
				{ value: '订单' },
				{ value: '退单' }
			],
			orderType: '全部',
			orderNOValue: '',
			goodsNameValue: '',
			dateValue: [],
			entName: '',
			shopName: ''
		}
	},
	created () {
		this.initFilters()
		this.getBaseCategory()
		this.getOrgan()
	},
	methods: {
		getBaseCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/reportScheme/getBaseCategory`
			}).then(res => {
				this.categoryList = res.data
				console.log(this.categoryList)
			})
		},
		getOrgan () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/reportScheme/organ/get`
			}).then(res => {
				this.organList = res.data
			})
		},
		bigCateChange () {
			this.samllCate = ''
			let params = {
				id: this.bigCate
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/reportScheme/getSmallCategory`,
				data: params
			}).then(res => {
				this.smallcategoryList = res.data
				console.log(this.smallcategoryList)
			})
		},
		organChange () {
			// this.samllCate = ''
			this.shop = ''
			if (this.organ === '' || this.organ === null) {
				this.shopList = []
			} else {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/reportScheme/shop/get`,
					data: this.organ
				}).then(res => {
					this.shopList = res.data
				})
			}
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.throughParams)
				let throughParams = this.$fxUtils.JSONparse(Params)
				if (throughParams) {
					this.orderNOValue = (throughParams.orderNo && throughParams.orderNo.value) || ''
					this.orderType = (throughParams.orderType && throughParams.orderType.value) || '全部'
					this.entName = (throughParams.entName && throughParams.entName.value) || ''
					this.shopName = (throughParams.shopName && throughParams.shopName.value) || ''
					this.userName = (throughParams.userName && throughParams.userName.value) || ''
					let startDate = throughParams.startDate.value.split(' ')
					let endDate = throughParams.endDate.value.split(' ')
					this.dateValue = [startDate[0], endDate[0]]
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
			}
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.orderType !== '全部') {
				let orderTypeObj = { 'field': 'orderType', 'data': this.orderType, 'op': 'eq' }
				cParams.push(orderTypeObj)
			}
			if (this.orderNOValue) {
				let orderNoObj = { 'field': 'orderNo', 'data': this.orderNOValue, 'op': 'cn' }
				cParams.push(orderNoObj)
			}
			if (this.orderNOValue) {
				let orderNoObj = { 'field': 'orderNo', 'data': this.orderNOValue, 'op': 'cn' }
				cParams.push(orderNoObj)
			}
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59`, 'op': 'le' }
				]
			} else {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.dateValue[1]} 23:59`, 'op': 'le' }
				]
			}
			if (this.goodsNameValue) {
				let goodsNameObj = { 'field': 'pname', 'data': this.goodsNameValue, 'op': 'cn' }
				filtersParams.push(goodsNameObj)
			}
			if (this.bigCate) {
				let bigCateObj = { 'field': 'categoryid', 'data': this.bigCate, 'op': 'eq' }
				filtersParams.push(bigCateObj)
			}
			if (this.samllCate) {
				let samllCateObj = { 'field': 'smallcategoryid', 'data': this.samllCate, 'op': 'eq' }
				filtersParams.push(samllCateObj)
			}
			if (this.shopName) {
				let shopNameObj = { 'field': 'storename', 'data': this.shopName, 'op': 'cn' }
				filtersParams.push(shopNameObj)
			}
			if (this.userName) {
				let userNameObj = { 'field': 'username', 'data': this.userName, 'op': 'cn' }
				filtersParams.push(userNameObj)
			}
			if (this.shop) {
				let shopObj = { 'field': 'organid', 'data': this.shop, 'op': 'eq' }
				filtersParams.push(shopObj)
			}
			return {
				filtersParams,
				cParams
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	.filters-box-row {
		display:flex
		margin-bottom: 10px
		&:last-child {
			margin-bottom: 0px
		}
		.data-picker-box {
			margin-right:10px
		}
		.order-type-box {
			margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
}
</style>

